import {
    DeviceId, DeviceTemplateId, ConsoleSessionId, UserId
} from "./ids";
import {Ticket} from "./ticket";
import * as momentbare from 'moment';
import {extendMoment} from 'moment-range';
import {Platform, platformFromString} from '@webmate-web-core/shared/types/platform';
import {ProviderType} from '../console/interfaces/console-config.interface';
const moment = extendMoment(momentbare);

export interface ConsoleSession {
    id: ConsoleSessionId,
    deviceName: string,
    deviceId: DeviceId,
    templateId: DeviceTemplateId,
    platform: Platform,
    providerType: ProviderType,
    userId: UserId,
    ticket: Ticket,
    keepAliveTime: number,
    consoleProperties: any,
    activeCapabilities: any,
    isActive: boolean,
    readOnly: boolean,
    created: string, /* TODO a own date class?*/
    lastTimestamp: string,
    endTime?: string,
    duration?: number
}

/** helper function to make front-end specific modification to Devices */
export function consoleSessionFromBackendObject(s: any): ConsoleSession {
    if (s.deviceName === undefined || s.deviceName.length <= 0) {
        s.deviceName = "Unnamed Device"; //front-end always names Devices in ConsoleSessions, no matter what the BackEnd says
    }
    s.activeCapabilities = {};
    s.platform = platformFromString(s.platform);
    s.ticket = s.consoleTicket;
    s.duration = moment(s.endTime || s.lastTimestamp).diff(moment(s.created), 'seconds');
    return s as ConsoleSession;
}
